module.exports = __webpack_public_path__ + "static/media/icon-community-calendar.1678a457.svg";